import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';
import { defineMessages, useIntl } from '@atlas/text';

export const messages = defineMessages({
    fontUnderline: { id: 'lblIconFontUnderline', defaultMessage: 'Underline' },
});

const FontUnderlineIcon = React.memo(function FontUnderlineIcon(props: TFontUnderlineIconProps): React.ReactElement {
    const intl = useIntl();

    return (
        <IconBase aria-label={intl.formatMessage(messages.fontUnderline)} {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.5 5.4V10.25C6.5 12.7353 8.51472 14.75 11 14.75C13.4853 14.75 15.5 12.7353 15.5 10.25V5.4C15.5 5.17909 15.3209 5 15.1 5H14.4C14.1791 5 14 5.17909 14 5.4V10.25C14 11.9069 12.6569 13.25 11 13.25C9.34315 13.25 8 11.9069 8 10.25V5.4C8 5.17909 7.82091 5 7.6 5H6.9C6.67909 5 6.5 5.17909 6.5 5.4ZM6.4 16.5C6.17909 16.5 6 16.6791 6 16.9V17.66C6 17.8809 6.17909 18.06 6.4 18.06H15.6C15.8209 18.06 16 17.8809 16 17.66V16.9C16 16.6791 15.8209 16.5 15.6 16.5H6.4Z"
            />
        </IconBase>
    );
});

export default FontUnderlineIcon;

// #region Types

export type TFontUnderlineIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function'
        ? () => <FontUnderlineIcon />
        : { ...IconBaseExample, render: FontUnderlineIcon };

// #endregion
